import { render, staticRenderFns } from "./orderDetailPop.vue?vue&type=template&id=321a77bb&scoped=true"
import script from "./orderDetailPop.vue?vue&type=script&lang=js"
export * from "./orderDetailPop.vue?vue&type=script&lang=js"
import style0 from "./orderDetailPop.vue?vue&type=style&index=0&id=321a77bb&prod&lang=scss"
import style1 from "./orderDetailPop.vue?vue&type=style&index=1&id=321a77bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a77bb",
  null
  
)

export default component.exports